import React, { useState } from 'react'
import styles from './swagger-api.module.css'

const CollapseButton = ({ onClick, isOpen }) => {
  return (
    <button onClick={onClick} className={styles.collapseAttributes}>
      {isOpen ? 'Collapse' : 'Expand'}
    </button>
  )
}

export default CollapseButton
